/** Paths where a user gesture must keep one key across retries, refreshes, and slow networks. */
export const HIGH_RISK_MUTATION_PATHS = [
    '/bookings',
    '/soap-notes',
    '/referrals',
    '/chat/',
    '/groups',
    '/assessment-enquiries',
    '/admin/bookings',
    '/admin/payouts',
    '/admin/refunds',
    '/admin/wallet',
    '/admin/therapists',
    '/admin/assessment-enquiries',
];
/** General JSON mutations: reuse the same key briefly for double-clicks. */
export const DEFAULT_IDEMPOTENCY_TTL_MS = 60_000;
/** Money, booking, and other irreversible intents: keep the key for the full server TTL window. */
export const HIGH_RISK_IDEMPOTENCY_TTL_MS = 24 * 60 * 60 * 1000;
export function isHighRiskMutationPath(endpoint) {
    const path = endpoint.split('?')[0] ?? endpoint;
    return HIGH_RISK_MUTATION_PATHS.some((prefix) => path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(prefix));
}
export function idempotencyTtlMsFor(endpoint) {
    return isHighRiskMutationPath(endpoint)
        ? HIGH_RISK_IDEMPOTENCY_TTL_MS
        : DEFAULT_IDEMPOTENCY_TTL_MS;
}
export function mutationFingerprint(method, endpoint, body) {
    return `${method.toUpperCase()}:${endpoint}:${body ?? ''}`;
}
//# sourceMappingURL=idempotency.js.map